import { render, staticRenderFns } from "./ConfigBox.vue?vue&type=template&id=424bed14&lang=html&"
import script from "./ConfigBox.vue?vue&type=script&lang=js&"
export * from "./ConfigBox.vue?vue&type=script&lang=js&"
import style0 from "./ConfigBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports